<app-page-header
  title="Home"
  active_item="Checkout"
  titleLink="/reports"
></app-page-header>

<div class="loading-webhook" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>

<form [formGroup]="checkout" (ngSubmit)="saveConfig()">
  <div class="row">
    <div class="col-12">
      <div class="card sales-summary rounded-10 shadow">
        <div class="card-header">
          <div class="card-title mb-0">
            {{ 'common.checkoutConfig' | translate }}
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-xl-6 col-lg-8 col-sm-12">
              <div class="form-group">
                <label for="txtLogoUrl" class="form-label">
                  {{ 'common.logoUrl' | translate }}
                </label>
                <input
                  id="txtLogoUrl"
                  type="text"
                  class="form-control"
                  formControlName="urlImagemLogo"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-4 col-lg-4 col-sm-6">
              <div class="form-group">
                <label class="form-label">
                  {{ 'common.buttonColor' | translate }}
                </label>
                <div class="d-flex align-items-center gap-2">
                  <input
                    type="color"
                    class="form-control form-control-color"
                    formControlName="colorButton"
                    style="max-width: 60px; padding: 10px;"
                  />
                  <input
                    type="text"
                    class="form-control"
                    formControlName="colorButton"
                    placeholder="#000000"
                  />
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-sm-6">
              <div class="form-group">
                <label class="form-label">
                  {{ 'common.windowColor' | translate }}
                </label>
                <div class="d-flex align-items-center gap-2">
                  <input
                    type="color"
                    class="form-control form-control-color"
                    formControlName="colorWindow"
                    style="max-width: 60px; padding: 10px;"
                  />
                  <input
                    type="text"
                    class="form-control"
                    formControlName="colorWindow"
                    placeholder="#FFFFFF"
                  />
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-sm-6">
              <div class="form-group">
                <label class="form-label">
                  {{ 'common.pageBackgroundColor' | translate }}
                </label>
                <div class="d-flex align-items-center gap-2">
                  <input
                    type="color"
                    class="form-control form-control-color"
                    formControlName="colorBotton"
                    style="max-width: 60px; padding: 10px;"
                  />
                  <input
                    type="text"
                    class="form-control"
                    formControlName="colorBotton"
                    placeholder="#F5F5F5"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <button
                type="submit"
                class="our-button btn btn-pill btn-primary float-end"
                [disabled]="checkout.invalid || !isLoaded"
              >
                <i class="fe fe-save me-1"></i>
                {{ 'common.save' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
